import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Agent } from '../agent.model';
import { AgentService } from '../agent.service';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';
import { AsyncPipe } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'fnsr-agent-list',
  standalone: true,
  imports: [LoadComponent, RouterModule, AsyncPipe],
  templateUrl: './agent-list.component.html',
  styleUrls: ['./agent-list.component.scss']
})
export class AgentListComponent {
  agents$: Observable<Agent[]>

  constructor(
    private agentService: AgentService,
  ) {
    this.agents$ = this.agentService.getAgents();
  }
}
